jQuery(function () {

  function setCookieIfNotExists() {
    var elArray = jQuery(".alert-bar");
    var closeBtn = elArray.find('.closeable');

    closeBtn.each(function (i, el) {
      var wrapperDiv = jQuery(el).closest('.alert-bar')
      if (wrapperDiv === undefined) return

      var wrapperDivId = wrapperDiv.attr('id')
      if (typeof jQuery.cookie(wrapperDivId) === 'undefined') {
        jQuery.cookie(wrapperDivId, 'true', {expires: 1});
        wrapperDiv.css('display', 'block');

      } else if (jQuery.cookie(wrapperDivId) === 'false') {
        wrapperDiv.css('display', 'none');
      }
    })
  }

  function showAlertBarsIfNotDismissed() {
    var elArray = jQuery(".alert-bar");
    var closeBtn = elArray.find('.closeable');

    closeBtn.each(function (i, el) {
      var wrapperDiv = jQuery(el).closest('.alert-bar')
      if (wrapperDiv === undefined) { return }

      var wrapperDivId = wrapperDiv.attr('id')
      if (jQuery.cookie(wrapperDivId) === 'true') {
        wrapperDiv.css('display', 'block');
      }
    })
  }

  function dismissAlertBars() {
    var elArray = jQuery(".alert-bar");
    var closeBtn = elArray.find('.alert-bar__closer');

    closeBtn.each(function (i, el) {
      var wrapperDiv = jQuery(el).closest('.alert-bar')
      if (wrapperDiv === undefined) { return }

      var wrapperDivId = wrapperDiv.attr('id')
      el.addEventListener('click', function (e) {
        e.preventDefault()
        jQuery.cookie(wrapperDivId, "false");
        wrapperDiv.css('display', 'none');
      })
    })
  }

  setCookieIfNotExists();
  showAlertBarsIfNotDismissed()
  dismissAlertBars()
});